import { getFormData, RestClient } from "clients/rest";

export type B100900Request = {
  excelFileData: File;
};

//Excel取込処理(商品マスタ)
export const B100900Shohin = (props: B100900Request) => {
  return RestClient.post("b100900/import/shohin", getFormData(props));
};

//Excel取込処理(単価マスタ)
export const B100900Tanka = (props: B100900Request) => {
  return RestClient.post("b100900/import/tanka", getFormData(props));
};

//Excel取込処理(取引先別単価マスタ)
export const B100900Toritanka = (props: B100900Request) => {
  return RestClient.post("b100900/import/toritanka", getFormData(props));
};
